var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrimsonLogoShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 1200,
    xmlns: "http://www.w3.org/2000/svg",
    clipRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    id: "svg_174"
  }, /*#__PURE__*/React.createElement("ellipse", {
    stroke: "null",
    ry: 596.00003,
    rx: 591.00001,
    id: "svg_173",
    cy: 600.00002,
    cx: 599.99998,
    fill: "#a72232"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_172"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_2",
    opacity: 0.998,
    d: "m181.99889,193.53369c278.667,0 557.333,0 836,0c1.48,5.926 2.65,11.926 3.5,18c0.67,60.333 0.67,120.667 0,181c-5.83,175.003 -52.83,338.003 -141,489c-67.291,114.996 -153.124,214.5 -257.5,298.5c-16.788,9.2 -33.122,8.53 -49,-2c-155.811,-127.032 -268.311,-285.199 -337.5,-474.5c-34.87,-98.016 -54.203,-199.016 -58,-303c-0.667,-63.667 -0.667,-127.333 0,-191c0.855,-5.42 2.022,-10.753 3.5,-16z",
    fill: "#fefefe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_169"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_30",
    d: "m677.50002,885.53369c1.165,-43.498 1.331,-87.165 0.5,-131c-0.717,0.544 -1.217,1.211 -1.5,2c-29.186,58.704 -57.019,118.037 -83.5,178c-4,1.333 -8,1.333 -12,0c-27.694,-61.055 -56.194,-121.722 -85.5,-182c-0.283,-0.789 -0.783,-1.456 -1.5,-2c-0.831,42.835 -0.665,85.502 0.5,128c0.123,11.388 0.956,22.721 2.5,34c1.762,2.768 4.262,4.268 7.5,4.5c5.333,0.333 10.667,0.667 16,1c0.5,0.5 1,1 1.5,1.5c0.667,4 0.667,8 0,12c-25.013,0.058 -50.013,0.058 -75,0c-0.667,-4 -0.667,-8 0,-12c0.5,-0.5 1,-1 1.5,-1.5c6.353,-0.487 12.686,-1.153 19,-2c1.786,-0.785 3.286,-1.951 4.5,-3.5c1.108,-6.615 1.775,-13.282 2,-20c0.167,-26.333 0.333,-52.667 0.5,-79c0.129,-29.357 -0.371,-58.69 -1.5,-88c-1.167,-2.5 -3,-4.333 -5.5,-5.5c-6.303,-0.942 -12.637,-1.609 -19,-2c-0.5,-0.5 -1,-1 -1.5,-1.5c-0.796,-4.255 -0.629,-8.421 0.5,-12.5c26.231,0.482 52.397,0.649 78.5,0.5c24.561,54.341 49.894,108.341 76,162c27.373,-53.406 52.539,-107.74 75.5,-163c25,1.112 50,1.279 75,0.5c1.3,4.45 1.3,8.95 0,13.5c-7.012,0.626 -14.012,1.46 -21,2.5c-1.878,1.543 -3.378,3.376 -4.5,5.5c-1.102,30.651 -1.602,61.317 -1.5,92c0.167,25.667 0.333,51.333 0.5,77c0.26,6.051 0.927,12.051 2,18c1.762,2.768 4.262,4.268 7.5,4.5c5.333,0.333 10.667,0.667 16,1c0.5,0.5 1,1 1.5,1.5c0.667,4 0.667,8 0,12c-33.801,-0.117 -67.634,0.05 -101.5,0.5c-1.333,-4.667 -1.333,-9.333 0,-14c6.655,-0.787 13.321,-1.453 20,-2c1.431,-0.465 2.597,-1.299 3.5,-2.5c2.227,-9.183 3.06,-18.516 2.5,-28z",
    fill: "#a72232"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_47"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_48",
    d: "m495.50002,752.53369c-0.999,41.83 -1.332,83.83 -1,126c-1.165,-42.498 -1.331,-85.165 -0.5,-128c0.717,0.544 1.217,1.211 1.5,2z",
    fill: "#bb5460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_49"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_50",
    d: "m677.50002,885.53369c0.332,-43.17 -0.001,-86.17 -1,-129c0.283,-0.789 0.783,-1.456 1.5,-2c0.831,43.835 0.665,87.502 -0.5,131z",
    fill: "#ecd1d5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svg_171"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_26",
    d: "m400.98125,306.53369c34.093,-2.769 67.093,1.898 99,14c0.915,0.828 1.581,1.828 2,3c-4.146,17.403 -6.479,35.069 -7,53c-4.267,0.297 -8.434,-0.036 -12.5,-1c-0.799,-8.99 -1.466,-17.99 -2,-27c-13.025,-14.094 -29.192,-21.594 -48.5,-22.5c-41.271,-3.995 -70.104,12.838 -86.5,50.5c-9.48,30.38 -8.48,60.38 3,90c23.016,45.603 59.85,63.103 110.5,52.5c13.403,-2.912 26.237,-7.412 38.5,-13.5c1.795,0.795 3.295,1.962 4.5,3.5c-2.145,5.954 -4.812,11.621 -8,17c-39.036,19.104 -79.703,23.437 -122,13c-42.185,-12.853 -68.685,-40.686 -79.5,-83.5c-5.697,-26.373 -4.364,-52.373 4,-78c16.408,-36.387 44.241,-58.887 83.5,-67.5c7.083,-1.557 14.083,-2.724 21,-3.5z",
    fill: "#a72232"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_28",
    d: "m809.98125,306.53369c34.093,-2.769 67.093,1.898 99,14c0.915,0.828 1.581,1.828 2,3c-4.146,17.403 -6.479,35.069 -7,53c-4.267,0.297 -8.434,-0.036 -12.5,-1c-0.799,-8.99 -1.466,-17.99 -2,-27c-13.025,-14.094 -29.192,-21.594 -48.5,-22.5c-41.271,-3.995 -70.104,12.838 -86.5,50.5c-9.48,30.38 -8.48,60.38 3,90c23.016,45.603 59.85,63.103 110.5,52.5c13.403,-2.912 26.237,-7.412 38.5,-13.5c1.795,0.795 3.295,1.962 4.5,3.5c-2.145,5.954 -4.812,11.621 -8,17c-39.036,19.104 -79.703,23.437 -122,13c-42.185,-12.853 -68.685,-40.686 -79.5,-83.5c-5.697,-26.373 -4.364,-52.373 4,-78c16.408,-36.387 44.241,-58.887 83.5,-67.5c7.083,-1.557 14.083,-2.724 21,-3.5z",
    fill: "#a72232"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrimsonLogoShield);
export default __webpack_public_path__ + "static/media/crimson-logo-shield.caf37cae746f4beb602a79498d850694.svg";
export { ForwardRef as ReactComponent };